export default class FinishPackingSlipModalController {
    constructor($uibModalInstance, $scope) {
        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;

        this.boot();
    }

    boot() {
        this.packingBeforeChanges = this.$scope.params.packingBeforeChanges;
        this.packingAfterChanges = this.$scope.params.packingAfterChanges;
    }

    confirm() {
        this.$uibModalInstance.close(true);
    };

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    };
}